export default {
	MAKE_SHIFT_PUBLIC_AVAILABLE: 'Make Shift Public Available',
	SWAP_SHIFT: 'Swap Shift',
	REQUEST_PUBLIC_SHIFT: 'Request Public Shift',
	ACCEPT_SWAP: 'Accept Swap',
};
